import { useLayoutState } from './LayoutContext';
import { useEffect } from 'react';

export const usePageTitle = (pageTitle: string) => {
  const { updatePageTitle } = useLayoutState();
  useEffect(() => {
    updatePageTitle(pageTitle);
  }, [pageTitle, updatePageTitle]);
};
